import textFit from 'textfit';
window.textFit = textFit;

function applyTextFit() {
	const el = document.getElementById('header__title--text-fit');
	if (el) {
		textFit(el, {
			alignHoriz: true,
			alignVert: true,
			multiLine: true,
			minFontSize: 10,
			maxFontSize: 800,
		});
	}
}

const observer = new ResizeObserver(() => {
	applyTextFit();
});
observer.observe(document.getElementById('header__title--text-fit'));
